import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";


@ValidatorConstraint({ async: false })
export class CustomIdDTO implements ValidatorConstraintInterface {
  validate(textId: string, _: ValidationArguments) {
    const REGEX_NUM = /^\d+$/
    const id = parseInt(textId);

    return REGEX_NUM.test(textId) && id > 0 && id <= 2147483647;
  }

  defaultMessage(_: ValidationArguments) {
    return 'Invalid id';
  }
}
